import themeConfig from '../themeConfig';

// 全局通用的 COLOR_KEY 配置（按 key 名称字符串来写，避免循环引用）
// 这些 key 的名字需要和 COLOR_KEY 枚举里的值保持一致

export const globalConfig: { [key: string]: (string | object)[] } = {
  standardBGColor: [themeConfig.colors.background, themeConfig.colors.backgroundDark],
  textColor: [themeConfig.colors.textColor, themeConfig.colors.textColorDark],
  topbarAfter: [
    {
      '-webkit-mask': 'linear-gradient(rgb(248, 247, 250), rgb(248, 247, 250) 18%, transparent 100%)',
      background:
        'linear-gradient( rgba(248, 247, 250, 0.7) 44%,rgba(248, 247, 250, 0.43) 73%,rgba(248, 247, 250, 0))',
    },
    {
      '-webkit-mask': 'linear-gradient(rgb(37, 41, 60), rgb(37, 41, 60) 18%, transparent 100%)',
      background:
        'linear-gradient(rgba(37, 41, 60, 0.7) 44%, rgba(37, 41, 60, 0.43) 73%, rgba(37, 41, 60, 0))',
    },
  ],
  navBackground: [themeConfig.colors.paper, themeConfig.colors.paperDark],
  boxShadow: [themeConfig.colors.boxShadow, themeConfig.colors.boxShadowDark],
  borderColor: [themeConfig.colors.boderColorLight, themeConfig.colors.boderColorDark],
  disabledBtn: [
    {
      backgroundColor: '#0000001f !important',
      color: '#00000042 !important',
    },
    {
      backgroundColor: '#ffffff1f !important',
      color: '#ffffff42 !important',
    },
  ],
  navItemText: ['#33303c99', '#e4e6f499'],
  countryListHighlight: [
    {},
    {
      '&.highlight': {
        backgroundColor: themeConfig.colors.primary800,
      },
      '&:hover': {
        backgroundColor: themeConfig.colors.primary800,
      },
    },
  ],
  scrollbarThumb: ['#5d596c33', '#cfd3ec4d'],
  reactDatepicker: [
    {
      '& .react-datepicker': {
        color: themeConfig.colors.textColor,
        backgroundColor: themeConfig.colors.paper,
        boxShadow: themeConfig.colors.boxShadow,
        '& .react-datepicker__day.react-datepicker__day--outside-month': {
          color: '#33303c61',
        },
        '& .react-datepicker__day.react-datepicker__day--disabled:not(.react-datepicker__day--selected)': {
          color: '#33303c61',
        },
        '& .react-datepicker__header__dropdown .react-datepicker__month-dropdown': {
          backgroundColor: themeConfig.colors.paper,
        },
        '& .react-datepicker__header__dropdown .react-datepicker__year-dropdown': {
          backgroundColor: themeConfig.colors.paper,
        },
      },
      '& .react-datepicker:not(.react-datepicker--time-only)': {
        '& .react-datepicker__time-container': {
          borderLeftColor: '#33303c1f',
        },
      },
    },
    {
      '& .react-datepicker': {
        color: themeConfig.colors.textColorDark,
        backgroundColor: themeConfig.colors.paperDark,
        boxShadow: themeConfig.colors.boxShadowDark,
        '& .react-datepicker__day.react-datepicker__day--outside-month': {
          color: '#e4e6f461',
        },
        '& .react-datepicker__day.react-datepicker__day--disabled:not(.react-datepicker__day--selected)': {
          color: '#e4e6f461',
        },
        '& .react-datepicker__header__dropdown .react-datepicker__month-dropdown': {
          backgroundColor: themeConfig.colors.paperDark,
        },
        '& .react-datepicker__header__dropdown .react-datepicker__year-dropdown': {
          backgroundColor: themeConfig.colors.paperDark,
        },
      },
      '& .react-datepicker:not(.react-datepicker--time-only)': {
        '& .react-datepicker__time-container': {
          borderLeftColor: '#e4e6f41f',
        },
      },
    },
  ],
};
